import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vfs-cust-img-imp-steps',
  templateUrl: './cust-img-imp-steps.component.html',
  styleUrls: ['./cust-img-imp-steps.component.scss']
})
export class CustImgImpStepsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
